module.exports = {
  currency: 'AUD',
  useLegacyFilter: false,
  languages: [
    { name: 'English', code: 'en', rtl: false },
  ],      
  general: {
    fontFamily: {
      en: 'Nexa'
    },
    showFavourites: true,
    showArtistImpressionText: true,
    showOnHoldGraphic: false,
    showSensorealBranding: true,
    showHomeButton: false,
    showPackagesWithSoldLots: false,
    showSoldNeighbourhoods: false,
    showSoldReleases: false,
    showSoldLabel: true,
    showSoldPrice: true,
    showLayoutSwitchToggle: false,
    canInteractSoldLivingOptions: false,
    canInteractSoldSubsections: false,
    canInteractSoldProperties: false,
    disclaimer: '',
    selectorHost: '',
    selectorName: '',
    analytics: false,
    ignorePropertyStatusFiltering: [''],
    showPrice: true
  },
  filter: {
    headingColour: '',
    dwellings: {
      builder: true,
      colourScheme: false,
      houseDesign: true,
      lotSize: true,
      livingSize: true
    }
  },
  landPage: {
    active: true,
    label: ''
  },
  turnkeyPage: {
    active: false,
    label: 'Townhomes',
    types: ['house', 'townhouse']
  },
  dwellingPage: {
    active: false,
    label: '',
    types: ['house', 'townhouse', 'apartment']
  },
  packagePage: {
    active: false,
    label: ''
  },
  displayHomesPage: {
    active: false,
    label: 'Display Village'
  },

  property_card: {
    headingColor: '',
    price_label: {
      land: 'Land Price From',
      package: 'Package Price',
      dwelling: 'House Price From',
      turnkey: 'Price',
      house_design: 'House Price From'
    }    
  },
  property_modal: {
    show_suitable_dwellings_button: false,
    suitable_dwellings_button_label: 'House Options'
  },
  rightSidebar: {
    backgroundColor: '#111f25',
    descriptionColor: '#fff',
    descriptionFontFamily: 'inherit',
    descriptionFontSize: '1.1rem',
    descriptionFontWeight: '400',
    descriptionLineHeight: '1.5rem',
    headingFontFamily: 'inherit',
    headingFontSize: '1.8rem',
    headingColor: '#bbd976',
    headingWeight: '400',
    propertyGuide: {
      active: true,
      items: [
        'Available',
        'Builder Lots',
        'Home Seeker',
        'On Hold',
        'Sold'
      ]
    }
  },
  bottomBar: {
    button: {
      color: '#fff',
      fontFamily: 'inherit',
      fontSize: '1.25rem',
      fontWeight: '400'
    },
    buttonActive: {
      color: '#000',
      fontFamily: 'inherit'
    }
  },
  subBottomBar: {
    button: {
      color: '#fff',
      fontFamily: 'inherit',
      fontSize: '1.1rem',
      fontWeight: '400',
      labelOffset: '0'
    },
    buttonActive: {
      color: '#000',
      fontFamily: 'inherit'
    }
  },
  labels: {
    exploreCommunities: {
      en: 'Explore Communities',
      ar: 'استكشاف المجتمعات'
    },
    builder: {
      en: 'Builder',
      ar: 'باني'
    },
    houseSize: {
      en: 'House Size',
      ar: 'حجم المنزل',
    },
    beds: {
      en: 'Beds',
      ar: 'أسرة',
    },
    baths: {
      en: 'Baths',
      ar: 'الحمامات',
    },
    cars: {
      en: 'Cars',
      ar: 'السيارات',
    },
    houseDesign: {
      en: 'House Design',
      ar: 'تصميم المنزل',
    },
    builderDesign: {
      en: 'Builder Design',
      ar: 'تصميم البناء',
    },
    landSize: {
      en: 'Land Size',
      ar: 'مساحة الأرض',
    },
    description: {
      en: 'Description',
      ar: 'وصف',
    },
    features: {
      en: 'Features',
      ar: 'سمات',
    },
    openingHours: {
      en: 'Opening Hours',
      ar: 'ساعات العمل',
    },
    name: {
      en: 'Name',
      ar: 'اسم'
    }
  }
}